import { render, staticRenderFns } from "./DobFAQ.vue?vue&type=template&id=26e898fc"
import script from "./DobFAQ.vue?vue&type=script&lang=js"
export * from "./DobFAQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports